<div class="modal-body width-900">
  <span class="modal-header">
    {{ receipt.rcpt_fileStreamID ? getRessource('Header') : getRessource('HeaderAddFile')}}
  </span>
	<div class="content app-layout-upload-1-auto">
		<div class="app-list-acceptbox app-space-top app-space-bottom"
		     *ngIf="receipt.rcpt_fileStreamID">
			<div class="list-header typo-small">
				<strong>Achtung!</strong>
			</div>
			<div class="list-row list-row-auto-1 typo-small">
				<div class="list-icon">
					<i class="far fa-triangle-exclamation c-red">
					</i>
				</div>
				<div class="list-single-line ">
          <span class="list-primary-text typo-small"
            [innerText]="data?.onlyNotes ? getRessource('HintTitleOnlyNotes') : getRessource('HintTitle')">
          </span>
					<span class="list-secondary-text typo-small"
			      [innerText]="data?.onlyNotes ? getRessource('HintTextOnlyNotes') : getRessource('HintText')">
					</span>
				</div>
			</div>
		</div>

		<div class="content grid-auto-1"
		     style="max-height: 640px">
			<div class="layout-1-auto">
				<div>
					<div class="chip app-chip-status"
					     style="display: flow"
					     [class.bg-blue]="showUpload && !showDocuments"
					     (click)="showUpload = true; showDocuments = false">
						Upload
					</div>
					<div class="chip app-chip-status"
					     style="display: flow"
					     [class.bg-blue]="!showUpload && showDocuments"
					     (click)="showUpload = false; showDocuments = true">
						Dokumente
					</div>
				</div>
				<div>
					<div class="chip app-chip-status"
					     [class.bg-blue]="!showUpload && !showDocuments"
					     (click)="showUpload = false; showDocuments = false">
						Dateien ({{ getFiles().length }})
					</div>
				</div>
			</div>
			<div class="content app-layout-upload-1-auto">
				<div (filesSelect)="onFilesSelect($event)"
				     *ngIf="showUpload"
				     [multiple]="true"
				     [dnd]="true"
				     style="margin: 8px 12px;"
				     class="app-drag-drop app-cursor-pointer" appExgDirectUploadV2>
					{{getResource('FileDropText')}}
				</div>
				<div *ngIf="showDocuments"
				     class="content">
					<div *ngIf="ConfigAttachmentTable.state === 2" class="splash empty">
						<p>{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
					</div>
					<div *ngIf="ConfigAttachmentTable.state === 1" class="splash loading">
						<p>{{getTranslation('Daten werden geladen')}}</p>
					</div>
					<cdk-tree *ngIf="ConfigAttachmentTable.state === 0"
					          [dataSource]="AttachmentTableData"
					          [treeControl]="ConfigAttachmentTable.treeControl">
						<cdk-nested-tree-node *cdkTreeNodeDef="let node" class="example-tree-node">
							<div class="list-row app-document-list-row">
								<div class="grid-auto-1">
									<ng-container *ngIf="node.dokMode !== 'Bericht' && node.dokMode !== 'Fragebogen'">
										<div style="cursor: pointer"
										     class="list-avatar-placeholder">
                        <span style="font-size: medium"
                              [tooltip]="getRessource('tooltip.edit')" flow="right">
                          <img src="{{excRest.computeUrl('ImageThumbnail',{dokID: node.dokID})}}" alt=""
                               class="list-avatar-placeholder"/>
                        </span>
										</div>
									</ng-container>
									<ng-container *ngIf="node.dokMode === 'Bericht'">
										<div class="typo-center app-space-right_075 app-cursor-pointer"
										     style="height: available">
                        <span flow="right" style="font-size: medium"
                              [tooltip]="getRessource('tooltip.openReport')">
                          <i class="fa-2xl fa-duotone fa-file-check "></i>
                        </span>
										</div>
									</ng-container>
									<ng-container *ngIf="node.dokMode === 'Fragebogen'">
										<div class="typo-center app-space-right_075 app-cursor-pointer">
                        <span style="font-size: medium"
                              [tooltip]="getRessource('tooltip.openQuestionnaire')" flow="right">
                          <i class="fa-2xl fa-duotone fa-clipboard-list"></i>
                        </span>
										</div>
									</ng-container>
									<div class="layout-auto-1-auto-grid-1-auto grid typo-small">
										<div class="list-metadata" style="margin-left:0">
											<div>
												<ng-container *ngIf="node.linked">
                            <span flow="left" style="font-size: medium"
                                  [tooltip]="getRessource('tooltip.linked')">
                              <i class="fal fa-link"></i>
                              <ng-container *ngIf="!node.dokTrackingPortalShare">
                                &nbsp;-&nbsp;
                              </ng-container>
                            </span>
												</ng-container>
												<ng-container *ngIf="node.dokTrackingPortalShare">
                            <span flow="left" style="font-size: medium"
                                  [tooltip]="getRessource('tooltip.trackingPortal')">
                              <i class="far fa-cloud"></i> -
                            </span>
												</ng-container>
												{{node.dok_enmIdent_DokTyp >= 0 && node.dokGroesse > 0 ? appSvc.file.calcFileSize(node.dokGroesse, false) + ' - ' : ''}}
												{{node.dokMode}}
											</div>
										</div>
										<div class="list-metadata ">
											<div
												class="typo-right">{{node.dokLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
											<div class="typo-right">{{node.dokCRU}}</div>
										</div>
										<div class="span-2">
											<div class="grid-1-auto">
												<div style="overflow: hidden">
													<strong>{{node.dokName}}{{node.dokErw}}</strong>
												</div>
												<div class="typo-right app-space-top_1">
                            <span flow="left" style="font-size: medium"
                                  [tooltip]="getRessource('tooltip.openInBrowser')">
                              <i class="search-action fa-eye"
                                 [class.fa-duotone]="node.dokMIME.includes('pdf') || node.dokMIME.includes('image/')"
                                 [class.fa-regular]="!node.dokMIME.includes('pdf') && !node.dokMIME.includes('image/')"
                                 [class.disabled]="!node.dokMIME.includes('pdf') && !node.dokMIME.includes('image/')"
                                 (click)="localConfig.openAttachmentInBrowser(node)">
                              </i>
                            </span>
													<span flow="left" style="font-size: medium"
													      [tooltip]="getRessource('tooltip.add')">
                              <i class="search-action fa-plus"
                                 [class.fa-duotone]="isValidPDFExtension(node.dokExtension)"
                                 [class.fa-regular]="!isValidPDFExtension(node.dokExtension)"
                                 [class.disabled]="!isValidPDFExtension(node.dokExtension)"
                                 (click)="localConfig.addAttachmentToUpload(node)">
                              </i>
                            </span>
												</div>
											</div>
										</div>
										<div class="span-2 list-secondary-text">{{node.dokBeschreibung}}</div>
									</div>
								</div>
							</div>
						</cdk-nested-tree-node>
						<cdk-nested-tree-node *cdkTreeNodeDef="let node; when: ConfigAttachmentTable?.hasChild"
						                      class="example-tree-node">
							<div class="list-row app-cursor-pointer"
							     *ngIf="node.source === 'document'"
							     cdkTreeNodeToggle>
								<div class="grid-auto-1" style="padding:0.5rem">
									<div class="list-avatar nobackground">
										<i class="far fa-fw"
										   [class.fa-folder-open]="ConfigAttachmentTable?.treeControl.isExpanded(node)"
										   [class.fa-folder]="!ConfigAttachmentTable?.treeControl.isExpanded(node)">
										</i>
									</div>
									<div class="layout-1-auto">
										<div class="list-metadata" style="margin-left:0">
											{{node.dokFolderCount}} {{getRessource(node.source + 'Count')}}
										</div>
										<div>
											<ng-container *ngIf="node.source === 'document'">
												{{enumSvc.getEnumerationText('DokTyp', node.dok_enmIdent_DokTyp)}}
											</ng-container>
										</div>
									</div>
								</div>
							</div>
							<div [hidden]="!ConfigAttachmentTable?.treeControl.isExpanded(node)">
								<ng-container cdkTreeNodeOutlet></ng-container>
							</div>
						</cdk-nested-tree-node>
					</cdk-tree>
				</div>
				<div class="content">
					<div class="list"
					     cdkDropList
					     cdkDropListOrientation="vertical"
					     (cdkDropListDropped)="onFileDrop($event)">
						<ng-container *ngFor="let selectedFile of selectedFiles; index as i">
							<div class="list-row  list-single-line list-row-auto-1-auto typo-small"
							     cdkDrag
							     *ngIf="selectedFile && selectedFile.extension">
								<div class="list-icon">
									<i class="fal" flow="right"
									   [tooltip]="!isValidPDF(selectedFile.size, selectedFile.extension) ? getRessource('NoSupported') : selectedFile.extension.toUpperCase()"
									   [class.c-red]="!isValidPDF(selectedFile.size, selectedFile.extension)"
									   [class.fa-file-pdf]="selectedFile.extension.toUpperCase() === 'PDF'"
									   [class.fa-file-excel]="selectedFile.extension.toUpperCase() === 'XLSX'"
									   [class.fa-file-word]="selectedFile.extension.toUpperCase() === 'DOCX'"
									   [class.fa-file-image]="selectedFile.extension.toUpperCase() === 'JPEG' || selectedFile.extension.toUpperCase() === 'PNG'"
									   [class.fa-exclamation-triangle]="!isValidPDF(selectedFile.size, selectedFile.extension)">
									</i>
								</div>
								<span class="list-primary-text" [class.c-red]="!isValidPDF(selectedFile.size, selectedFile.extension)">
                    {{
                    (i+1) + '.: ' + getResource('File', {
                        Filename: selectedFile.name,
                        Filesize: appSvc.file.calcFileSize(selectedFile.size, false)
                            + (!proofFileSize(selectedFile.size) ? ' - ' + getRessource('NoSupported') : '')
                    }) + ' '
									}}
                  </span>
								<div class="">
									<i class="fal fa-arrow-up search-filter-action"
									   (click)="move(i, -1)"
									   [class.disabled]="i === 0"></i>
									<i class="fal fa-arrow-down search-filter-action"
									   (click)="move(i, 1)"
									   [class.disabled]="i === selectedFiles.length - 1"></i>
									<i (click)="delete(selectedFile)"
									   [class.c-red]="!isValidPDF(selectedFile.size, selectedFile.extension)"
									   [class.fa-trash]="isValidPDF(selectedFile.size, selectedFile.extension)"
									   [class.fa-times]="!isValidPDF(selectedFile.size, selectedFile.extension)"
									   class="fa-light search-filter-action">
									</i>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="spawn-modal-actions">
		<button (click)="close()" class="md-btn">
			{{getGlobal('Cancel')}}
		</button>
		<button (click)="upload()"
		        [disabled]="getFiles().length == 0"
		        class="md-btn">
			{{ receipt.rcpt_fileStreamID ? getRessource('Upload') : getRessource('UploadAdd')}}
		</button>
	</div>
</div>
